import { FC } from "react";

interface Props {
  name: string;
  icon: React.FC<any>;
  value: string | undefined;
}

const InstructureItemStatus: FC<Props> = ({ value, name, icon: Icon }) => {
  return (
    <div className="flex items-center fds-l:pl-7 py-1.5  fds-l:py-0 gap-1.5  fds-l:gap-2">
      <div className="fds-l:w-10 w-9 h-8  fds-l:h-10 relative">
        <Icon className="text-fds-icon-brand absolute h-8   w-8   fds-l:w-10 fds-l:h-10 z-20" />
        <div className="rounded-full absolute z-10 bottom-0 -right-1 h-6  w-6  fds-l:h-fds-30 fds-l:w-fds-30 bg-fds-brand-light " />
      </div>
      <div className="flex fds-l:flex-col fds-l:items-start items-center gap-y-0.5">
        <p className="fds-l:headline-sm title-md-demibold">{` ${value} `}</p>
        <p className="fds-l:body-md body-sm mr-0.5">{name}</p>
      </div>
    </div>
  );
};
export default InstructureItemStatus;
